import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Skeleton } from 'antd';
import { InfoCircleOutlined, ShoppingCartOutlined, DownloadOutlined } from '@ant-design/icons';

import { profileSelectors, fetchDocuments } from '../../../features/profile';

const ProfileDocuments = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const documents = useSelector(profileSelectors.selectDocuments);
    const isLoading = useSelector(profileSelectors.selectDocumentsLoading);
    const error = useSelector(profileSelectors.selectDocumentsError);

    useEffect(() => {
        dispatch(fetchDocuments());
    }, [dispatch]);

    const handleViewProducts = () => {
        navigate('/catalog');
    };

    const handleDownload = (url, filename) => {
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
    };

    const columns = [
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Тип',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: 'Дата',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'Размер',
            dataIndex: 'size',
            key: 'size',
        },
        {
            title: 'Действия',
            key: 'actions',
            render: (_, record) => (
                <Button
                    type="link"
                    icon={<DownloadOutlined />}
                    onClick={() => handleDownload(record.url, record.name)}
                    style={{ color: '#D00202' }}
                >
                    Скачать
                </Button>
            ),
        },
    ];

    if (isLoading) {
        return (
            <div className="profile-orders-table">
                <Skeleton active paragraph={{ rows: 5 }} title={{ width: '30%' }} />
            </div>
        );
    }

    if (!documents || documents.length === 0) {
        return (
            <div className="profile-empty-section">
                <div className="profile-empty-content">
                    <InfoCircleOutlined className="profile-empty-icon" />
                    <span className="profile-empty-text">Пока нечего скачивать.</span>
                </div>
                <Button
                    className="profile-action-btn"
                    onClick={handleViewProducts}
                    icon={<ShoppingCartOutlined />}
                >
                    Просмотр товаров
                </Button>
            </div>
        );
    }

    return (
        <div className="profile-orders-table">
            <Table
                columns={columns}
                dataSource={documents}
                rowKey="id"
                pagination={{
                    pageSize: 10,
                    showSizeChanger: false,
                }}
            />
        </div>
    );
};

export default ProfileDocuments;
